export default {
  // common
  ok: '확인',
  cancel: '취소',
  send: '전송',
  // time
  timeJustNow: '방금 전',
  timeMinutesAgo: '{n}분 전',
  timeHoursAgo: '{n}시간 전',
  timeYesterday: '어제',
  // chat toolbar titles
  chatEmotion: '이모지',
  chatSendImage: '이미지 전송',
  chatSendFile: '파일 전송',
  chatReceipt: '수신 확인 메시지',
  chatSendVoice: '음성 전송',
  chatGroupInfo: '그룹 정보',
  // chat area
  chatSomeoneAtMe: '누군가 나를 언급했습니다',
  chatNewMessages: '새 메시지 {n}개',
  chatBackToBottom: '맨 아래로',
  chatReceiptPrefix: '[수신 확인] ',
  // message actions / tips
  chatNoMoreMessages: '더 이상 메시지가 없습니다',
  chatDeleteConfirm: '이 메시지를 삭제하시겠습니까?',
  chatDeleteTitle: '메시지 삭제',
  chatRecallConfirm: '이 메시지를 회수하시겠습니까?',
  chatRecallTitle: '메시지 회수',
  chatRecalled: '메시지가 회수되었습니다',
  chatLocateFail: '원본 메시지를 찾을 수 없습니다',
  chatResendUnsupported: '이 메시지는 자동 재전송을 지원하지 않습니다. 수동으로 다시 보내주세요.',
  // input disabled tips
  chatGroupDissolved: '그룹이 해체되었습니다',
  chatGroupQuit: '더 이상 이 그룹에 속해 있지 않습니다',
  chatGroupBanned: '그룹이 차단되었습니다',
  chatUserBanned: '이 계정은 차단되었습니다',
  chatBanReason: ', 사유: ',
  // message status / readed
  msgReaded: '읽음',
  msgUnread: '읽지 않음',
  msgAllReaded: '모두 읽음',
  msgSomeReaded: '{n}명 읽음',
  msgSending: '전송 중',
  msgSendFail: '전송 실패',
  msgRecall: '다시 전송',
  msgMenuDelete: '삭제',
  msgMenuRecall: '회수',
  // voice record
  recordTitle: '음성 녹음',
  recordDuration: '길이',
  recordStart: '시작',
  recordPause: '일시정지',
  recordResume: '재개',
  recordStop: '중지',
  recordPlay: '재생',
  recordStopPlay: '재생 중지',
  recordRestart: '다시 녹음',
  recordSend: '지금 전송',
  recordStateReady: '시작 전',
  recordStateRunning: '녹음 중...',
  recordStatePaused: '녹음 일시정지됨',
  recordStateStopped: '녹음 중지됨',
  msgReadedTab: '읽음 ({n})',
  msgUnreadTab: '읽지 않음 ({n})',
  // language
  langLabel: '언어',
  langZh: '中文',
  langEn: 'English'
}
